/**
 * This are a set of utility functions for implementing a spinner input.
 */

/**
 * Step forward to the next option after the supplied value.
 * @param  {string[]} options   all option in the spinner
 * @param  {string} value       supplied value
 * @return {string}             the next option after the supplied value.
 */
const incrementOption = (options, value = '') => {
  const valueIdx = options.indexOf(value);
  if (valueIdx === -1) {
    return options[0];
  }
  if (options.length <= valueIdx + 1) {
    return options[0];
  }
  return options[valueIdx + 1];
};

/**
 * Step backward to previous next option after the supplied value.
 * @param  {string[]} options all option in the spinner
 * @param  {string}   value   supplied value
 * @return {string}           the previous option after the supplied value.
 */
const decrementOption = (options, value = '') => {
  const valueIdx = options.indexOf(value);
  if (valueIdx === -1) {
    return options[options.length - 1];
  }
  if (valueIdx <= 0) {
    return options[options.length - 1];
  }
  return options[valueIdx - 1];
};

/**
 * Set the value of of the spinner to null.
 *
 * @return {null}         the null value of the spinner.
 */
const clearOption = () => undefined;

/**
 * A function that takes a keyboard letter or number input and returns the possible value from
 * options that it matches.
 *
 * @param  {string[]} options   Array of all options
 * @param  {string}   key       letter or number from the keyboard input
 * @param  {number}   maxLength the maximum length of a string match
 * @param  {string}   inputBuffer the value of the current inputs buffer
 * @return {object}   the closes match with the match type
 */
const jumpToOption = (options, key, maxLength, inputBuffer) => {
  let matchType = 'none';
  let foundOption;
  const lowerCaseKey = key.toLowerCase();
  if (lowerCaseKey.length > 1) {
    return {
      matchType,
      foundOption: undefined,
      updatedBuffer: inputBuffer
    };
  }
  const lowerCaseOptions = options.map(option => option === null || option === void 0 ? void 0 : option.toLowerCase());

  /*
    * If we have a character key-press do a preliminary search to see if it exists anywhere in
    * the options.
    */
  const preliminaryMatchIdx = lowerCaseOptions.findIndex(option => option.includes(lowerCaseKey));
  if (preliminaryMatchIdx === -1) {
    return {
      matchType,
      foundOption,
      updatedBuffer: inputBuffer
    };
  }
  matchType = 'preliminary';
  foundOption = options[preliminaryMatchIdx];
  let testBuffer = `${inputBuffer}${lowerCaseKey}`.slice(-maxLength);
  const updatedBuffer = testBuffer;
  let foundOptionIdx = -1;
  const optionFinder = option => option === null || option === void 0 ? void 0 : option.includes(testBuffer);
  while (testBuffer.length > 1 && foundOptionIdx === -1) {
    foundOptionIdx = lowerCaseOptions.findIndex(optionFinder);
    if (foundOptionIdx === -1) {
      testBuffer = testBuffer.slice(1);
    }
  }
  if (testBuffer.length === maxLength && foundOptionIdx !== -1) {
    matchType = 'full';
    foundOption = options[foundOptionIdx];
  }
  return {
    matchType,
    foundOption,
    updatedBuffer
  };
};

export { clearOption as c, decrementOption as d, incrementOption as i, jumpToOption as j };
//# sourceMappingURL=spinnerNavigation-BdO3lpWM.js.map
